import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const WaterDamagePage = lazy(() => import('../pages/services/water-damage/page'));
const FireDamagePage = lazy(() => import('../pages/services/fire-damage/page'));
const MoldRemediationPage = lazy(() => import('../pages/services/mold-remediation/page'));
const StormDamagePage = lazy(() => import('../pages/services/storm-damage/page'));
const ReconstructionPage = lazy(() => import('../pages/services/reconstruction/page'));
const CommercialPage = lazy(() => import('../pages/services/commercial/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const WaterDamageFirst24HoursPage = lazy(() => import('../pages/blog/water-damage-first-24-hours/page'));
const PreventMoldAfterFloodPage = lazy(() => import('../pages/blog/prevent-mold-after-flood/page'));
const InsuranceClaimPage = lazy(() => import('../pages/blog/homeowners-insurance-claim-water-damage/page'));
const StructuralDrying101Page = lazy(() => import('../pages/blog/structural-drying-101/page'));
const MercedCountyFloodSeasonPage = lazy(() => import('../pages/blog/merced-county-flood-season/page'));
const FireDamageRestorationBlogPage = lazy(() => import('../pages/blog/fire-damage-restoration-smoke-odor-recovery/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const CalculatorPage = lazy(() => import('../pages/calculator/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/services/water-damage',
    element: <WaterDamagePage />,
  },
  {
    path: '/services/fire-damage',
    element: <FireDamagePage />,
  },
  {
    path: '/services/mold-remediation',
    element: <MoldRemediationPage />,
  },
  {
    path: '/services/storm-damage',
    element: <StormDamagePage />,
  },
  {
    path: '/services/reconstruction',
    element: <ReconstructionPage />,
  },
  {
    path: '/services/commercial',
    element: <CommercialPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/water-damage-first-24-hours',
    element: <WaterDamageFirst24HoursPage />,
  },
  {
    path: '/blog/prevent-mold-after-flood',
    element: <PreventMoldAfterFloodPage />,
  },
  {
    path: '/blog/homeowners-insurance-claim-water-damage',
    element: <InsuranceClaimPage />,
  },
  {
    path: '/blog/structural-drying-101',
    element: <StructuralDrying101Page />,
  },
  {
    path: '/blog/merced-county-flood-season',
    element: <MercedCountyFloodSeasonPage />,
  },
  {
    path: '/blog/fire-damage-restoration-smoke-odor-recovery',
    element: <FireDamageRestorationBlogPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/cost-calculator',
    element: <CalculatorPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
